module.exports = __webpack_public_path__ + "static/media/ic_add_green.61a28022.svg";